export default "__VITE_ASSET__dM9y_NLq__"